// extracted by mini-css-extract-plugin
export default {"h1":"style_h1__tAIW4","h2":"style_h2__3UHBi","h":"style_h__AFZlH"};